module.exports = __webpack_public_path__ + "img/2.f1f6ad3a.webp";